import { SET_PAGE, SET_PAGE_TOTAL } from '../actions/page'

const initialState = {
	page: 1,
	total: 1
}

export default function page(state = initialState, action){
	switch(action.type){
		case SET_PAGE:
			return { page: action.page, total: state.total };

		case SET_PAGE_TOTAL:
			return { page: state.page, total: action.total };

		default:
			return state;
	}
}
